import Swal from "sweetalert2";

export function showSuccess(message) {
  return Swal.fire({
    icon: "success",
    title: "Success",
    text: message,
    confirmButtonColor: "#3085d6",
  });
}

export function showError(message) {
  return Swal.fire({
    icon: "error",
    title: "Oops...",
    text: message,
    confirmButtonColor: "#d33",
  });
}

export function showInfo(message) {
  return Swal.fire({
    icon: "info",
    title: "Info",
    text: message,
    confirmButtonColor: "#3085d6",
  });
}

export function showErrorWithStatus(errorMessage, status) {
  return Swal.fire({
    icon: "error",
    title: "Verification Failed",
    html: `
      <div style="text-align: left;">
        <p style="margin-bottom: 12px;"><strong>Error:</strong> ${errorMessage}</p>
        <p style="margin-bottom: 0;"><strong>Current Status:</strong> <span style="color: #d33; font-weight: 600;">${status || 'Unknown'}</span></p>
      </div>
    `,
    confirmButtonColor: "#d33",
    confirmButtonText: "OK",
  });
}
